import {
    Injectable,
    inject,
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import {
    PdfPreviewDialogComponent,
    PdfPreviewDialogData,
} from '../components/pdf-preview-dialog/pdf-preview-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class PdfPreviewService {
    private readonly dialog =
        inject(MatDialog);

    open(
        data: PdfPreviewDialogData
    ): void {
        this.dialog.open<
            PdfPreviewDialogComponent,
            PdfPreviewDialogData
        >(
            PdfPreviewDialogComponent,
            {
                width:
                    'min(1180px, calc(100vw - 32px))',

                maxWidth:
                    'calc(100vw - 32px)',

                maxHeight:
                    'calc(100dvh - 32px)',

                panelClass:
                    'pdf-preview-dialog-panel',

                autoFocus: false,
                restoreFocus: false,

                data,
            }
        );
    }
}